module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseInfo.type !== 0 && !_vm.loading) ? _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构名称",
      "placeholder": "请输入机构名称",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgName),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgName", $$v)
      },
      expression: "data.orgName"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgType",
    attrs: {
      "title": "机构类型",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.orgTypeArry,
      "placeholder": "请选择机构类型"
    },
    model: {
      value: (_vm.data.orgType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgType", $$v)
      },
      expression: "data.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('my-selector', {
    ref: "orgDocumentsType",
    attrs: {
      "title": "证件类型",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.orgCardArry,
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.data.orgDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsType", $$v)
      },
      expression: "data.orgDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgDocumentsNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsNo", $$v)
      },
      expression: "data.orgDocumentsNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "orgDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.data.orgDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsValidity", $$v)
      },
      expression: "data.orgDocumentsValidity"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证书",
      "placeholder": "请输入资质证书",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationProve", $$v)
      },
      expression: "data.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "keyboard": "number",
      "placeholder": "请输入证书编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationNo", $$v)
      },
      expression: "data.orgQualificationNo"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgBusinessScope",
    attrs: {
      "title": "经营范围",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.BusinessScope,
      "placeholder": "请选择经营范围"
    },
    model: {
      value: (_vm.data.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgBusinessScope", $$v)
      },
      expression: "data.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册地址",
      "placeholder": "请输入注册地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterAddress", $$v)
      },
      expression: "data.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgAddress", $$v)
      },
      expression: "data.orgAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisteredCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本(万元)",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisteredCapital),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisteredCapital", $$v)
      },
      expression: "data.orgRegisteredCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgController),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgController", $$v)
      },
      expression: "data.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_next
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.type === 0 && !_vm.loading) ? _c('one-look', {
    attrs: {
      "baseInfo": _vm.baseInfo,
      "propData": _vm.data,
      "hasResp": _vm.hasResp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f367b3"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Agency/One.vue
// module id = 1045
// module chunks = 1